"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    carousel: {
        ariaLabel: {
            control: '{{control}} {{name}}, {{num}} of {{total}}',
        },
    },
};
